import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {AuthService} from 'services/authService';
import {UserMessageService} from 'services/userMessageService';
import {AccountAPI} from 'services/accountAPI';

@inject(Router, AuthService, UserMessageService, AccountAPI)
export class Breadcrumbs {
    constructor(router, authService, userMessageService, api) {
        this.api = api;
        this.router = router;
        this.authService = authService;
        this.userMessageService = userMessageService;

        this.captureKey == null;
        const account = this.authService.getAccount();

        this.app_name = window.whitelabel ? window.app_name : "Magnfi";
        this.org_name = account.org_name ? account.org_name : "Magnfi";

        this.isAdmin = this.authService.getUser().role == "WLADMIN" || this.authService.getUser().role == "ADMIN";

        this.id = this.authService.getUser();
        console.log("this.id", this.id);
        this.current_time = "00:00:00";
        this.timezone = '';
        this.duration1 = 'week';
        this.duration2 = 'week';
        this.duration3 = 'week';
        this.duration4 = 'week';
        this.duration5 = 'week';
        this.heading = '';
    }
    activate(model) {
        this.startTime();
        this.heading = model.heading;
    }
    startTime() {

        this.offset = new Date().getTimezoneOffset();
        if (this.offset < 0)
            this.offset = "GMT +" + this.offset / -60;
        else
            this.offset = "GMT -" + this.offset / 60;

        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        //this.timezone = new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1];

        // to get current time/ date.
        var date = new Date();
        // to get the current hour
        var h = date.getHours();
        // to get the current minutes
        var m = date.getMinutes();
        //to get the current second
        var s = date.getSeconds();
        // AM, PM setting
        var session = "AM";

        //conditions for times behavior 
        if (h == 0) {
            h = 12;
        }
        if (h >= 12) {
            session = "PM";
        }

        if (h > 12) {
            h = h - 12;
        }
        m = (m < 10) ? m = "0" + m : m;
        s = (s < 10) ? s = "0" + s : s;

        //putting time in one variable
        var time = h + ":" + m + " " + session;
        //putting time in our div
        //$('#clock').html(time); 
        this.current_time = time;
        //to change time in every seconds
        setTimeout(this.startTime.bind(this), 1000);
    }
}
